import { Input } from "reactstrap";
import {
  Button,
  Modal,
  Table
} from "react-bootstrap";

const toDateFormat = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString("fr-Fr", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};


var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'MAD',
});
const format = (price) => formatter.format(price)

export const ConfirmResendDepositModal = ({show, operation, handleClose, handleClick}) => {
  if (!operation)
    return <></>
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table id="invoice">
            <thead>
              <tr>
                <th className="border-0">Date</th>
                <th className="border-0">Amount</th>
                <th className="border-0">Token</th>
                <th className="border-0">Destination</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{toDateFormat(operation.createdAt)}</td>
                <td style={{color:'green'}}>{format(operation.amount)}</td>
                <td>{operation.cpOperationToken}</td>
                <td>{operation.phoneNumber}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={() => handleClick(operation.id)}>Resend</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
